export const debounceTextClassName = "k-input k-input-solid debounce-text k-input-md k-rounded-md";
export const debounceTextClassNameSmall =
    "k-input k-input-solid debounce-text k-input-sm k-rounded-sm limit-debounce-height";
